const pad = (n: number) => String(n).padStart(2, "0");

/** Local calendar date as YYYY-MM-DD. */
export function toISODate(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function today(): string {
  return toISODate(new Date());
}

const toUTC = (date: string) => {
  const [y, m, d] = date.split("-").map(Number);
  return Date.UTC(y, m - 1, d);
};

export function daysBetween(from: string, to: string): number {
  return Math.round((toUTC(to) - toUTC(from)) / 86400000);
}

export function addDays(date: string, n: number): string {
  return new Date(toUTC(date) + n * 86400000).toISOString().slice(0, 10);
}

/** Monday = 0 … Sunday = 6 */
export function weekdayIndex(date: string): number {
  return (new Date(toUTC(date)).getUTCDay() + 6) % 7;
}
